<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter" :ignoreMaxTableItemLimit="true"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesStoolDeliverTaskResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" :ignoreMaxTableItemLimit="true"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <b-button
                                        :disabled="notSelected"
                                        variant="outline-primary"
                                        size="sm"
                                        v-loading="loading"
                                        element-loading-spinner="el-icon-loading"
                                        element-loading-background="rgba(0, 0, 0, 0.8)"
                                        @click="printPackingList">生成箱单
                                    </b-button>
                                    <b-button
                                        :disabled="notSelected"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="confirmDialogVisible = true">确认发货
                                    </b-button>
                                    <b-button
                                        :disabled="$store.state['sithMesStoolDeliverTask'].checkedItems.length != 1"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="closeDeliver">发货关闭
                                    </b-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog
            title="提示"
            :visible.sync="confirmDialogVisible"
            width="30%">
            <span>确认已经上传质量文件了吗?</span>
            <span slot="footer" class="dialog-footer">
            <el-button @click="confirmDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="confirmDeliver">确 定</el-button>
          </span>
        </el-dialog>
    </div>
</template>
<script>
// Author Shi Wen Long
// Date 2021-09-06 16:00:49

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import emApiMixin from "@/mixin/em/common/api";
import commonViewsUtil from "@/utils/commonViewsUtil";
import moment from "moment";
import emCustomVuexMixin from "@/mixin/em/customVuex";

export default {
    name: "sithMesStoolDeliverTaskListView",
    mixins: [emCommonListMixin, emCommonGotoMixin, emApiMixin, commonViewsUtil, emCustomVuexMixin],
    data() {
        return {
            loading: false,
            confirmDialogVisible: false,
        }
    },
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    methods: {
        confirmDeliver() {

            let deliverUrl = this.$store.state.sithMesStoolDeliverList.baseModuleUrl + "/sithMesStoolDeliverTask/confirmDeliver";
            this.$store.dispatch("api/postReportDownload", {
                url: deliverUrl,
                data: this.$_emCustomVuexMixin_checkItems,

            }, {root: true})
                .then(() => {
                    commonViewsUtil.showSuccess(this, "确认发货成功！");
                    this.$refs["emListFilter"].doQuery();
                    this.confirmDialogVisible = false;
                })
        },
        closeDeliver() {

            let row = this.$store.state[this.modelName].entity;
            row.consignStatus = '已关闭';
            row.closeTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
            let param = {'entity': 'sithMesStoolDeliverTask'};
            param.entityAux = row;
            param.strCrud = 'Edit'
            this.$store.dispatch('emBase/emBaseCustomSave', param)
                .then(response => {
                    commonViewsUtil.showSuccess(this, "关闭成功！");
                    this.$refs["emListFilter"].doQuery();
                });
        },
        printPackingList() {
            this.loading = true;
            let deliverUrl = this.$store.state.sithMesStoolDeliverList.baseModuleUrl + "/sithMesStoolDeliverTask/generatePackingList";
            this.$store.dispatch("api/postReportDownload", {
                url: deliverUrl,
                data: this.$_emCustomVuexMixin_checkItems,
            }, {root: true})
                .then(res => {
                    let blob = new Blob([res], {
                        type: `application/zip;charset-UTF-8`
                    });
                    let objectURL = URL.createObjectURL(blob);
                    let downEle = document.createElement('a');
                    downEle.href = objectURL;
                    downEle.setAttribute('download', '批量下载箱单.zip');
                    // document.body.appendChild(downEle);
                    downEle.click();
                    this.loading = false;
                })
        },
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }
    },
    mounted() {
        this.$refs["emListFilter"].doQuery();
    }
};
</script>
